import { defaultTemplateName } from '../../config/defaults';
import releaseSettings from '../../config/releaseSettings';


function fillLeadingZeros(value, minDigitCount) {
    let zeros = "";
    for (let i = 1; i < minDigitCount; i++) {
        if (value >= Math.pow(10, i)) { break; }
        zeros += "0";
    }
    return zeros + value;
}

//formatted date
function getDate() {
    const date = new Date();
    const day = fillLeadingZeros(date.getDate(), 2);
    const month = fillLeadingZeros(date.getMonth() + 1, 2);//month is returned in range 0-11, so we add 1 to get 1-12 range
    const year = fillLeadingZeros(date.getFullYear(), 4);
    const hour = date.getHours();
    const minute = date.getMinutes();

    return year + month + day + ' ' + hour + ':' + minute;
}

//const value with included generation date
function getSettings() {
    const defaultSettings = require('../../assets/settings').default;
    const stateColorSettings = this.state.colorSettings;
    const stateTemplateSettings = this.state.templateSettings;
    const localStorageTemplateSettings = JSON.parse(localStorage.getItem("onlineCreatorB2B-settings"));
    const localStorageWidgetSettings = JSON.parse(localStorage.getItem("onlineCreatorB2B-widget"));
    const objSave = {...defaultSettings, ...stateColorSettings, ...stateTemplateSettings};
    const templateName = this.state.templateName || defaultTemplateName;
    
    if(localStorageTemplateSettings.hasOwnProperty("sizeChartSiteID")){
    for (const key in localStorageTemplateSettings) {
      if (localStorageTemplateSettings.hasOwnProperty(key) && objSave.hasOwnProperty(key)) {
        objSave[key] = localStorageTemplateSettings[key];
      }
      if(localStorageWidgetSettings!==null && localStorageWidgetSettings!==undefined) {
        objSave["widgetPosition"] = localStorageWidgetSettings
      }
    }
    }
    return {
        "@": {
            "Name": templateName,
            "Date": getDate(),
            "Version": releaseSettings.eShopVersion || "2023.1.1",
            "FP": "",
            "Lock": 0,
            "HasPassword": 0,
            "PhoneNo":"12 681 43 00 wew. 2",
            "WWW": "https://kreator.comarchesklep.pl/",
            "TN": "S"
        },
        "Settings": JSON.stringify(objSave)
    };
}

export default getSettings;